module.exports = __webpack_public_path__ + "img/PP_1-30.6e23f955.png";